module.exports = __webpack_public_path__ + "static/media/main idea.483969b2.mp3";